<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="approvalComments" :class="{'isNews': isNews}">
            <van-nav-bar
                title="审批意见"
                left-text="审批办理"
                left-arrow
                v-if="isNews != true"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <div class="commonLabels" v-if="!isReadOnly">
                    <span>常用标签：</span>
                    <van-button plain size="small" @click="commonWords('同意')">
                        同意
                    </van-button>
                    <van-button plain size="small" @click="commonWords('不同意')">
                        不同意
                    </van-button>
                </div>
                <van-field
                    rows="2"
                    autosize
                    type="textarea"
                    maxlength="80"
                    v-model="approvalOpinion"
                    class="iconfont sm-beizhu textarea"
                    placeholder="请输入审批意见"
                    :disabled="isReadOnly"
                ></van-field>
            </section>
            <div class="currencyFooterStyle" v-if="!isReadOnly">
                <button @click="saveOpinion">
                    保存
                </button>
            </div>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'approval-comments',
    components: {},
    props: {},
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.backPathName = from.name;
        });
    },
    data() {
        return {
            isNews: false,
            isReadOnly: false,
            allApprovalOpinion: [],
            approvalOpinion: '',
            backPathName: '',
            newsToken: '',
        };
    },
    computed: {},
    watch: {},
    created() {
        this.initPage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
                params: {
                    commentsCallback: true,
                },
            });
            this.$router.go(-1);
        },

        async initPage() {
            this.$toast.loading({ overlay: true, duration: 0 });
            this.newsToken = this.$route.params.thisToken;
            this.isNews = this.$route.params.isNews;
            this.isReadOnly = this.$route.params.isReadOnly;
            this.allApprovalOpinion = await this.getAllApprovalOpinion();
            const res = (this.allApprovalOpinion || []).filter(item => item.config_phase_id === this.$route.params.currentBusinessProcess.ConfigPhaseId);
            if (res.length > 0) {
                this.approvalOpinion = res[0].opinion;
            }
            this.$toast.clear();
        },

        // 常用标签按钮
        commonWords(val) {
            this.approvalOpinion = this.approvalOpinion + val;
        },

        async saveOpinion() {
            this.$toast.loading({ overlay: true, duration: 0 });
            const opinionData = [{
                business_code: this.$route.params.approvalData.BusinessCode || this.$route.params.businessInstanceInfo.BusinessCode,
                business_instance_id: this.$route.params.approvalData.BusinessInstanceId || this.$route.params.approvalData.business_instance_id,
                config_phase_id: this.$route.params.currentBusinessProcess.ConfigPhaseId,
                business_process_id: this.$route.params.currentBusinessProcess.BusinessProcessId,
                phase_node: this.$route.params.currentBusinessProcess.PhaseNode,
                config_phase_name: this.$route.params.currentBusinessProcess.BusinessPhaseName,
                opinion: this.approvalOpinion,
            }];
            const res = await this.setLinkApprovalOpinion(opinionData);
            if (res) {
                this.$toast.success('保存成功。');
            }
            this.$toast.clear();
        },

        // 获取所有审批意见
        getAllApprovalOpinion() {
            const businessCode = this.$route.params.approvalData.BusinessCode || this.$route.params.businessInstanceInfo.BusinessCode;
            const businessInstanceId = this.$route.params.approvalData.business_instance_id;
            return this.$axios.$post(`/interfaceApi/basicplatform/mobile/get_allopinion/${businessCode}/${businessInstanceId}`, { token: this.newsToken });
        },
        // 设置环节审批意见
        setLinkApprovalOpinion(requestDate) {
            return this.$axios.$post('/interfaceApi/basicplatform/mobile/add_opinion', requestDate, { token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus">
.approvalComments
    height 100%
    position relative
    display flex
    flex-direction column
    section
        overflow hidden
        height 0
        flex 1
        .commonLabels
            padding 0 15rpx
            margin-top 13rpx
            display flex
            align-items: center
            >span
                font-size 14rpx
                color #979EA7
            .van-button
                color #E93743
                margin-right: 14rpx
                background: rgba(233,55,67,0.1);
                border-radius: 2rpx;
                border: 1px solid rgba(233,55,67,0.2);
        .textarea
            padding 0 15rpx
            margin-top 13rpx
            position relative
            &:before
                position absolute
                top 6rpx
                left 26rpx
            textarea
                text-indent 25rpx
                &.van-field__control
                    border 1px solid #D7D7D7
                    border-radius 4px
                    padding 5rpx 10rpx
                    height 130rpx !important
</style>
